import React from 'react';

import Container from 'components/Container';
import Image from 'components/Image';
import Spaced from 'components/Spaced';
import Typography from 'components/Typography';
import { useExhibition } from 'contexts/ExhibitionContext';
import { makeImageSources, stringifyMultipleDesigners } from 'utils';

export interface ObjectProps {
  value: string;
}

const Object: React.FCWithChildren<ObjectProps> = ({ value }) => {
  const { productsMap } = useExhibition();

  const product = productsMap[Number(value)];

  const { pictures, name, designers } = product;
  const firstPicture = pictures[0] || {};

  return (
    <Container>
      <Spaced>
        <Image aspectRatio="letterbox" {...makeImageSources(firstPicture)} alt={name} />
        <div>
          <Typography uppercase block>
            {name}
          </Typography>
          <Typography uppercase block color="faded">
            {stringifyMultipleDesigners(designers)}
          </Typography>
        </div>
      </Spaced>
    </Container>
  );
};

export default Object;
